module.exports = __webpack_public_path__ + "img/GrowmarkFSLogo.6e90195f.png";